import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';
import type { LocationJobsResponse } from '@core/locations-types';
import type { ID } from '@core/ngrx-legacy';

@Injectable({ providedIn: 'root' })
export class LocationsJobsHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public fetch(id: ID): Observable<LocationJobsResponse> {
    return this.httpApi.get(`/locations/${id}/offers`);
  }
}
